import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'

export const RevokeTokenPopup = ({ isOpen, onClose, onRevoke }) => (
  <SimplePopup
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onRevoke}
    title={I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.revoke_token_popup.title')}
    confirmLabel={I18n.t('publisher.action.yes')}
    cancelLabel={I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.revoke_token_popup.cancel')}
  >
    {HtmlParser(I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.revoke_token_popup.body'))}
  </SimplePopup>
)
